<template>
  <div class="pb-terms pb-grey-bck ps-3 pe-3 pt-3 pb-3">
    <div class="pb-title-row">
      <small class="text-uppercase pull-left d-block w-100 text-semibold">{{ $t('upsell.recommended') }}</small>
      <slot name="product_name"></slot>
      <slot name="tooltip"></slot>
    </div>
    <slot name="description"></slot>
    <slot name="price"></slot>
    <div class="pb-terms pull-left d-block w-100 mb-0">
      <div class="form-group pull-left w-100 pl-md-0 pr-md-0 mb-0">
        <slot name="add-to-cart-button"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Upsell',

  props: {
    service_label: String
  }
};
</script>
